import { z } from "zod";
import { appearanceSchema } from "./appearance";
import { chatSchema } from "./chat";
import { handoffSchema } from "./handoff";
import { languagesSchema } from "./languages";
import { memorySchema } from "./memory";
import { modelsSchema } from "./models";
import { personaSchema } from "./persona";
import { restrictionsSchema } from "./restrictions";
import { substitutionsSchema } from "./substitutions";
import { supportSchema } from "./support";
import { toolsSchema } from "./tools";
import { voiceSchema } from "./voice";
import { whatsappSchema } from "./whatsapp";

/**
 * Per-retailer agent settings, stored as versioned JSON in AgentConfig. The
 * zod schema is the contract: the admin UI edits it, the runtime reads it, and
 * defaults fill anything an older version didn't have.
 */
export const agentSettingsSchema = z.object({
	persona: personaSchema,
	languages: languagesSchema,
	models: modelsSchema,
	tools: toolsSchema,
	/** Suggested first messages shown to the shopper. */
	starterPrompts: z.array(z.string().max(120)).max(6).default([]),
	appearance: appearanceSchema,
	chat: chatSchema,
	voice: voiceSchema,
	support: supportSchema,
	handoff: handoffSchema,
	substitutions: substitutionsSchema,
	memory: memorySchema,
	restrictions: restrictionsSchema,
	/** On the retailer's WhatsApp numbers: voice replies, the location question, wording. */
	whatsapp: whatsappSchema,
	/** Extra retailer rules appended to the prompt (delivery, returns, ID checks). */
	extraInstructions: z.string().max(4000).default(""),
	/** Store used when a request does not name one (Store.externalId). */
	defaultStoreExternalId: z.string().optional(),
});

export type AgentSettings = z.infer<typeof agentSettingsSchema>;
